import React from 'react'

const BlueArrowIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.125 0.69943L15.725 7.29943C15.825 7.39943 15.896 7.50776 15.938 7.62443C15.9793 7.7411 16 7.8661 16 7.99943C16 8.13276 15.9793 8.25776 15.938 8.37443C15.896 8.4911 15.825 8.59943 15.725 8.69943L9.125 15.2994C8.94167 15.4828 8.71267 15.5788 8.438 15.5874C8.16267 15.5954 7.925 15.4994 7.725 15.2994C7.525 15.1161 7.42067 14.8871 7.412 14.6124C7.404 14.3371 7.5 14.0994 7.7 13.8994L12.6 8.99943L1.425 8.99943C1.14167 8.99943 0.904001 8.90376 0.712 8.71243C0.520667 8.52043 0.425 8.28276 0.425 7.99943C0.425 7.71609 0.520667 7.47876 0.712001 7.28743C0.904001 7.09543 1.14167 6.99943 1.425 6.99943L12.6 6.99943L7.7 2.09943C7.51667 1.9161 7.42067 1.68276 7.412 1.39943C7.404 1.11609 7.5 0.882763 7.7 0.69943C7.88333 0.49943 8.11667 0.399429 8.4 0.399429C8.68333 0.399429 8.925 0.49943 9.125 0.69943Z"
        fill="#3249D7"
      />
    </svg>
  )
}

export default BlueArrowIcon
